import React from 'react';

import SPBreadcrumb from '../../../components/base/SPBreadcrumb';
import SPEmployeeListSearchForm from '../../../components/carRental/employeeManagement/SPEmployeeListSearchForm';
import SPEmployeeListTable from '../../../components/carRental/employeeManagement/SPEmployeeListTable';
import SPEmployeeListDrawer from '../../../components/carRental/employeeManagement/SPEmployeeListDrawer';
import SPAssociatedStoresModal from '../../../components/carRental/employeeManagement/SPAssociatedStoresModal';
import SPContentWrap from '../../../components/carRental/base/SPContentWrap';

interface PagePropsType {
	enums?: any;
	permission?: any;
}
const Page: React.FC<PagePropsType> = props => {
	const { enums, permission } = props;

	return (
		<>
			<SPBreadcrumb title="员工列表" />
			<SPContentWrap className="common-margin-top">
				<SPEmployeeListSearchForm enums={enums} />
			</SPContentWrap>
			<SPEmployeeListTable enums={enums} permission={permission} />
			<SPEmployeeListDrawer enums={enums} />
			<SPAssociatedStoresModal enums={enums} />
		</>
	);
};

export default Page;
